/*
 * ===========================================================================
 * [StrongGate Limited] [http://www.stronggate.com]
 * Copyright (c) 2022. All rights Reserved.
 * Unauthorized access, use, dissemination, distribution, reproduction of this
 * file, or a portion of, in any form is prohibited and unlawful. If you receive
 * this file, and you are not an authorized company employee, or you believe you
 * have received this file in error, please notify the sender (or originator)
 * and promptly delete this file.
 *
 * Project:
 * File: TeamInfoVO.ts
 * Created by: Kevin
 * Create Date: 2022-12-12 18:50
 * Version Number: 1.0
 * Version Description:
 *
 * =============================================================================
 */

export class TeamInfoVO {
    public id: string = ""
    public name: string = ""
    public teamFqdn: string = ""
    public ownerUserId: string = ""
    public userId: string = ""
    public createdAt: string = ""
    public teamUID: string = "";

    // geoContinentId and continentName were removed on 2026-08-27: TeamInfo no longer carries a
    // continent. team-site does not hold one — dnsd derives it from the region — so the field had
    // been arriving as 0 and rendering as "Unknown-Continent(0)". Ask dnsd if a continent is
    // needed here again; do not reinstate a field the API does not send.
    public geoRegionId: number = 0;
    public regionName: string = "";

    public reset(): void {
        this.id = "";
        this.name = "";
        this.teamFqdn = "";
        this.ownerUserId = "";
        this.userId = "";
        this.createdAt = "";
        this.teamUID = "";
        this.geoRegionId = 0;
        this.regionName = "";
    }

    public isValid(): boolean {
        return this.id != ""
            && this.name != ""
            && this.teamFqdn != ""
            && this.ownerUserId != ""
            && this.createdAt != ""
            && this.teamUID != "";
    }
}